<template>
    <section id="additional-services">
        <div class="list-group-item collapse-element d-flex justify-content-between align-items-center">
            <b>{{ $t('co.additional_services', { currentStep: currentStep, steps: numberOfSteps }) }}</b>
            <b-button variant="text" v-if="!isVisible" @click="openCollapse">
                <font-awesome-icon icon="far fa-pencil" />
            </b-button>
        </div>
        <b-collapse class="list-group-item" tag="div" v-model="isVisible">
            <div class="row">
                <div class="col-12 my-2">
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="dpReduction"
                        name="checkbox-1"
                        value="accepted"
                        unchecked-value="not_accepted"
                    >
                        {{ entry.dp_reduction_article.label }}
                        <small class="pl-2">{{ $n(entry.dp_reduction_article.price, 'currency') }} / {{ $t('pds.buybox.permonth') }}</small>
                    </b-form-checkbox>
                </div>
                <div class="col-12 my-2">
                    <b-form-checkbox
                        id="checkbox-2"
                        v-model="additionalDriver"
                        name="checkbox-2"
                        value="accepted"
                        unchecked-value="not_accepted"
                    >
                        {{ entry.additional_driver_article.label }}
                        <small class="pl-2">{{ $n(entry.additional_driver_article.price, 'currency') }} / {{ $t('pds.buybox.permonth') }}</small>
                    </b-form-checkbox>
                </div>
                <div class="col-12 my-2" v-if="additionalDriver === 'accepted'">
                    <b-form-group :label="$t('co.additional_services.additional_driver.name')" label-for="name">
                        <b-form-input
                            id="name"
                            :placeholder="$t('co.additional_services.additional_driver.name')"
                            type="text"
                            maxlength="255"
                            required
                            :state="additionalDriverNameState"
                            v-model="additionalDriverName"
                            aria-describedby="additional-driver-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="additional-driver-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group :label="$t('co.additional_services.additional_driver.age')" label-for="driverAge">
                        <b-form-input
                            id="driverAge"
                            :placeholder="$t('co.additional_services.additional_driver.age')"
                            type="number"
                            min="18"
                            max="99"
                            required
                            :state="additionalDriverAgeState"
                            v-model="additionalDriverAge"
                            aria-describedby="additional-driver-age-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="additional-driver-age-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group :label="$t('co.additional_services.additional_driver.license_years')" label-for="licenseYears">
                        <b-form-input
                            id="licenseYears"
                            :placeholder="$t('co.additional_services.additional_driver.license_years')"
                            type="number"
                            min="0"
                            max="99"
                            required
                            :state="additionalDriverLicenseYearsState"
                            v-model="additionalDriverLicenseYears"
                            aria-describedby="additional-driver-license-error"
                        ></b-form-input>
                        <b-form-invalid-feedback id="additional-driver-license-error">{{$t('co.error.required_field')}}</b-form-invalid-feedback>
                    </b-form-group>
                </div>
            </div>
            <div class="row d-flex justify-content-end mt-4">
                <div class="col-12 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-mobile-full-width" @click="submit" v-if="!isSubmitting" :disabled="!valid">{{$t('co.button.continue')}}</button>
                    <button type="button" class="btn btn-primary btn-mobile-full-width disabled" v-else>{{$t('co.button.loading')}}</button>
                </div>
            </div>
        </b-collapse>
    </section>
</template>

<script>
import { BCollapse, BButton, BFormCheckbox, BFormInput, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue'
import { EventBus } from '../../event-bus'

export default {
    name: 'CheckoutAdditionalServices',
    components: {
        BFormCheckbox,
        BFormInput,
        BFormGroup,
        BFormInvalidFeedback,
        BCollapse,
        BButton,
    },
    props: {
        entry: null,
        currentStep: {
            type: Number,
        },
        numberOfSteps: {
            type: Number,
        },
    },
    data() {
        return {
            error: false,
            isVisible: false,
            isSubmitting: false,
            additionalDriver: 'not_accepted',
            dpReduction: 'not_accepted',
            additionalDriverName: '',
            additionalDriverAge: null,
            additionalDriverLicenseYears: 0,
        }
    },
    methods: {
        initFields() {
            this.additionalDriver = this.entry.additional_driver ? 'accepted' : 'not_accepted'
            this.dpReduction = this.entry.dp_reduction ? 'accepted' : 'not_accepted'
            if (this.additionalDriver && this.entry.additional_driver_details) {
                this.additionalDriverName = this.entry.additional_driver_details.name
                this.additionalDriverAge = this.entry.additional_driver_details.age
                this.additionalDriverLicenseYears = this.entry.additional_driver_details.drivers_license_since
            }
        },
        submit() {
            if (this.isSubmitting || !this.valid) {
                return
            }

            let body = {
                subscription_uuid: this.entry.uuid,
                additional_driver: this.additionalDriver === 'accepted',
                dp_reduction: this.dpReduction === 'accepted',
            }
            if (body.additional_driver) {
                body.additional_driver_name = this.additionalDriverName
                body.additional_driver_age = Number(this.additionalDriverAge)
                body.additional_driver_license_since = Number(this.additionalDriverLicenseYears)
            }

            this.isSubmitting = true
            this.$axios.put('/api/v1/checkout/update_subscription', body).then(response => {
                if (response.data) {
                    if (response.data == 'vehicle_not_available') {
                        alert(this.$t('checkout.redirect_error'))
                        this.$router.push('/')
                    }

                    this.isSubmitting = false
                    this.isVisible = false
                    this.error = false
                    EventBus.$emit('checkout-open-step-' + (this.currentStep + 1), null)
                    EventBus.$emit('update-subscription-payload', response.data.data)
                    document.getElementById('payment-data').scrollIntoView()
                } else {
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        init() {
            this.isVisible = true
            this.initFields()
        },
        openCollapse() {
            EventBus.$emit('close-all-collapses', null)
            this.$nextTick(() => {
                this.init()
            })
        },
        closeCollapse() {
            this.isVisible = false
        }
    },
    computed: {
        getPrice() {
            const price = this.$root.whitelabel.setting('show_price_without_taxes') ? this.entry.delivery.deliveryCosts_net : this.entry.delivery.deliveryCosts
            const vatText = this.$root.whitelabel.setting('show_price_without_taxes') ? this.$t('general.net') : ''
            return `${this.$root.whitelabel.getFormatetPrice(price)} ${vatText}`
        },
        additionalDriverNameState() {
            return this.additionalDriverName.length > 4 && this.additionalDriverName.length <= 255
        },
        additionalDriverAgeState() {
            return this.additionalDriverAge >= 18 && this.additionalDriverAge <= 99
        },
        additionalDriverLicenseYearsState() {
            return this.additionalDriverLicenseYears >= 0 && this.additionalDriverLicenseYears <= 99
        },
        valid() {
            const hasAdditionalDriver = this.additionalDriver === 'accepted'
            return !(hasAdditionalDriver && (!this.additionalDriverName || !this.additionalDriverAge || this.additionalDriverLicenseYears < 0))
        }
    },
    mounted() {
        EventBus.$on('close-all-collapses', this.closeCollapse)
        EventBus.$on('checkout-open-step-' + this.currentStep, this.init);
    },
    watch: {
        entry() {
            if (this.entry !== null) {
                this.initFields()
            }
        }
    },
}
</script>
